import { render, staticRenderFns } from "./CreateAreaForm.vue?vue&type=template&id=7469141b&"
import script from "./CreateAreaForm.vue?vue&type=script&lang=js&"
export * from "./CreateAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports